/* eslint-disable react/prop-types */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Twitch = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, 
    //	color = '#fff',
    _c = _a.styles, 
    //	color = '#fff',
    styles = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { style: __assign({ width: size }, styles), viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", fill: "#000000" },
        React.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
        React.createElement("path", { d: "M9 10v8l7-4zm12-4h-7.58l3.29-3.29L16 2l-4 4h-.03l-4-4-.69.71L10.56 6H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 14H3V8h18v12z" })));
};
export default Twitch;
